<template>
  <div class="timeContainer">
    <div class="monitor-list">
      <!-- 左边按钮 -->
      <div class="btn" id="left_btn" @click="scrollLeft">
        <i class="el-icon el-icon-caret-left" />
      </div>
      <!-- 中间列表 -->
      <div id="list-box" class="list-box">
        <div id="list" class="list">
          <div v-for="(item, index) in monitorList" :key="index" class="list-item" :class="{ checked: tabIndex == index }" @click="handleTimeTab(index)">
            <span></span>
            <p>{{ item }}</p>
          </div>
        </div>
      </div>
      <!-- 右边按钮 -->
      <div class="btn" id="right_btn" @click="scrollRight">
        <i class="el-icon el-icon-caret-right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "top",
  data() {
    return {
      monitorList: [],
      imgList: {
        alive: require("../assets/images/icon-yy-mr.png"),
        down: require("../assets/images/icon-yy-mr.png"),
      },
      loading: false,
      tabIndex: 0,
    };
  },
  computed: {},
  props: {
    timeScrollList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    paperYear: {
      type: Number,
    },
  },
  watch: {
    $route: {
      handler(val) {
        // timeScrollList:
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    setTimeout(() => {
      this.monitorList = this.timeScrollList;
      var leftMove = 0;
      const listEl = document.getElementById("list");
      const listBox = document.getElementById("list-box");

      // 添加容错处理，如果组件已被卸载或DOM不存在则不执行后续逻辑
      if (!listEl || !listBox) return;

      const boxLength = listBox.clientWidth;
      const allLength = this.monitorList.length * 100;
      this.monitorList.forEach((element, index) => {
        if (element == this.paperYear) {
          this.tabIndex = index;
          leftMove = (this.tabIndex - 10) * 100;
        }
      });
      listEl.style.left = "-" + (this.tabIndex - 9) * 100 + "px";

      const leftBtn = document.getElementById("left_btn");
      const rightBtn = document.getElementById("right_btn");

      if (leftMove + boxLength + 100 == allLength && rightBtn) {
        rightBtn.style.visibility = "hidden";
      }

      if (this.monitorList.length <= 10) {
        if (rightBtn) rightBtn.style.visibility = "hidden";
        if (leftBtn) leftBtn.style.visibility = "hidden";
      } else {
        if (this.tabIndex - 9 <= 0 && leftBtn) {
          leftBtn.style.visibility = "hidden";
        }
      }
    }, 500);
  },
  methods: {
    // 左滑动逻辑
    scrollLeft() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const allLength = this.monitorList.length * 100;
      const boxLength = document.getElementById("list-box").clientWidth;
      if (allLength < boxLength) return;
      const listEl = document.getElementById("list");
      const leftBtn = document.getElementById("left_btn");
      const rightBtn = document.getElementById("right_btn");
      const leftMove = Math.abs(parseInt(window.getComputedStyle(listEl, null)?.left));

      if (leftMove + boxLength - 100 < boxLength) {
        // 到最开始的时候
        listEl.style.left = "0px";
        leftBtn.style.visibility = "hidden";
        rightBtn.style.visibility = "visible";
      } else {
        listEl.style.left = "-" + (leftMove - 100) + "px";
        rightBtn.style.visibility = "visible";
        if (leftMove + boxLength - 100 == boxLength) {
          leftBtn.style.visibility = "hidden";
        }
      }
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    // 右滑动逻辑
    scrollRight() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const allLength = this.monitorList.length * 100;
      const boxLength = document.getElementById("list-box").clientWidth;

      if (allLength < boxLength) {
        return;
      }
      const listEl = document.getElementById("list");
      const leftBtn = document.getElementById("left_btn");
      const rightBtn = document.getElementById("right_btn");
      const leftMove = Math.abs(parseInt(window.getComputedStyle(listEl, null)?.left));

      if (leftMove + boxLength + 100 > allLength) {
        listEl.style.left = "-" + (allLength - boxLength) + "px";
        rightBtn.style.visibility = "hidden";
      } else {
        listEl.style.left = "-" + (leftMove + 100) + "px";
        leftBtn.style.visibility = "visible";
        if (leftMove + boxLength + 100 == allLength) {
          rightBtn.style.visibility = "hidden";
        }
      }
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },
    handleTimeTab(index) {
      this.tabIndex = index;
      this.$emit("childrenValue", this.monitorList[index]);
    },
  },
};
</script>

<style lang="scss" scoped>
.timeContainer {
  .monitor-list {
    display: flex;
    justify-content: space-between;
    position: relative;
    padding: 0 40px;
    &::before {
      position: absolute;
      height: 1px;
      background: #b8eaeb;
      width: 100%;
      content: "";
      top: 15px;
      left: 0;
    }
    .btn {
      text-align: center;
      cursor: pointer;
      font-size: 24px;
      color: #b3b3b3;

      .el-icon-caret-left {
        position: absolute;
        left: 0;
        top: 38px;
      }

      .el-icon-caret-right {
        position: absolute;
        right: 0;
        top: 38px;
      }
    }

    .list-box {
      width: 6000px;
      overflow: hidden;
      .list {
        width: 6000px;
        display: flex;
        transform: all 0.3s;
        flex-wrap: wrap;
        position: relative;
        padding-top: 10px;
        .checked {
          position: relative;
          &::before {
            width: 10px;
            height: 10px;
            border: 3px solid #b8eaeb;
            content: "";
            position: absolute;
            left: 50%;
            margin-left: -7.5px;
            top: -2.5px;
            background: #2d8cf0;
            border-radius: 50%;
          }
          p {
            color: #2d8cf0;
          }
        }

        .list-item {
          text-align: center;
          cursor: pointer;
          margin: 0 15px;
          width: 70px;
          span {
            width: 10px;
            height: 10px;
            background: #b8eaeb;
            display: inline-block;
            border-radius: 50%;
            margin-bottom: 15px;
          }
        }
        position: relative;
        left: 0;
        transition: left 0.3s;
      }
    }
  }
}
</style>
